import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Marketingoversigt',
  tiles: {
    followers: 'Følgere',
    delivered_messages: 'Leverede beskeder',
    open_rate: 'Åbningsrate',
    click_rate: 'Klikrate',
    spam_report_rate: 'Spamrapportrate',
    unsubscribe_rate: 'Afmeldingsrate',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Tilmeldingskilde',
      count: 'Antal',
      percentage: 'Procent',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Skabelon',
      delivered: 'Leveret',
      open_rate: 'Åbningsrate',
      click_rate: 'Klikrate',
      spam_report_rate: 'Spamrapportrate',
      unsubscribe_rate: 'Afmeldingsrate',
    },
  },
  labels: {
    no_data: 'Ingen data',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
